import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxifrompunetomumbaiairport() {



  const cardData = {


  keyword: "Taxi From Pune to Mumbai Airport",

  headingDescription: "Trustline Cab provides reliable taxi from Pune to Mumbai Airport with safe, comfortable, and affordable transportation for domestic and international travelers. Whether you are catching an early morning flight, arriving late at night, traveling for business, corporate meetings, family vacations, or medical purposes, our experienced chauffeurs ensure timely pickups and a hassle-free journey. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, flight-friendly scheduling, easy online booking, well-maintained vehicles, and 24/7 customer support, Trustline Travels is your trusted choice for Pune to Mumbai Airport taxi services.",

topPlaces: [
  {
    title: "Chhatrapati Shivaji Maharaj International Airport",
    description: "Mumbai's primary international airport and one of India's busiest aviation hubs, serving domestic and international passengers with world-class facilities and extensive flight connectivity."
  },
  {
    title: "Terminal 1",
    description: "Terminal 1 is the domestic terminal at Mumbai Airport, serving passengers traveling to major cities and destinations across India."
  },
  {
    title: "Terminal 2",
    description: "Terminal 2 is Mumbai Airport's modern integrated terminal serving international and domestic flights with premium lounges, dining, shopping, and advanced passenger facilities."
  },
  {
    title: "Mumbai Airport Arrivals",
    description: "The arrivals area provides baggage collection, immigration, customs, passenger assistance, and convenient transportation facilities for arriving travelers."
  },
  {
    title: "Mumbai Airport Departures",
    description: "The departures area offers check-in, security screening, boarding gates, lounges, dining, shopping, and essential services for departing passengers."
  },
  {
    title: "Mumbai Airport Lounges",
    description: "Mumbai Airport offers premium lounges with comfortable seating, refreshments, Wi-Fi, business facilities, and other amenities for passengers waiting for their flights."
  },
  {
    title: "Mumbai Airport Parking",
    description: "Mumbai Airport provides convenient parking facilities for passengers and visitors, with designated areas for short-term and long-term vehicle parking."
  }
],






"services": [
  {
    "name": "Taxi from Pune to Mumbai Airport",
    "description": "Book Taxi from Pune to Mumbai Airport with clean AC cars, professional drivers, fixed fares, doorstep pickup, and comfortable airport transfers."
  },
  {
    "name": "Pune to Mumbai Airport Drop Charges",
    "description": "Check Pune to Mumbai Airport Drop Charges with transparent pricing, affordable fares, and multiple vehicle options."
  },
  {
    "name": "Pune to Mumbai Airport Cab Services",
    "description": "Choose Pune to Mumbai Airport Cab Services for reliable airport transfers with experienced chauffeurs and well-maintained vehicles."
  },
  {
    "name": "Pune to Mumbai Airport Car",
    "description": "Book a Pune to Mumbai Airport Car with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicle options."
  },
  {
    "name": "Pune to Mumbai Airport Car Hire",
    "description": "Hire a Pune to Mumbai Airport Car with professional drivers, comfortable seating, and affordable airport transfer packages."
  },
  {
    "name": "Pune to Mumbai Airport Drop Taxi",
    "description": "Reserve Pune to Mumbai Airport Drop Taxi for direct airport transfers with fixed pricing and punctual pickup."
  },
  {
    "name": "Pune to Mumbai Airport Drop Taxi Service",
    "description": "Our Pune to Mumbai Airport Drop Taxi Service provides safe, reliable, and comfortable airport transportation."
  },
  {
    "name": "Pune to Mumbai Taxi Hire",
    "description": "Book Pune to Mumbai Taxi Hire for airport transfers, business trips, and family travel with chauffeur-driven vehicles."
  },
  {
    "name": "Taxi Service from Pune to Mumbai Airport",
    "description": "Choose Taxi Service from Pune to Mumbai Airport for hassle-free airport travel with clean vehicles and experienced drivers."
  },
  {
    "name": "Taxi to Pune from Mumbai Airport",
    "description": "Book Taxi to Pune from Mumbai Airport with doorstep pickup, fixed fares, and comfortable intercity travel."
  },
  {
    "name": "Taxi From Pune to Mumbai Airport",
    "description": "Reserve Taxi From Pune to Mumbai Airport for affordable airport transfers with AC vehicles and professional chauffeurs."
  },
  {
    "name": "Pune to Mumbai Airport Taxi",
    "description": "Choose Pune to Mumbai Airport Taxi for safe, affordable, and comfortable airport transportation."
  },
  {
    "name": "Pune to Mumbai Airport Cab",
    "description": "Book Pune to Mumbai Airport Cab with Sedan, SUV, Innova Crysta, Ertiga, and premium cars for reliable travel."
  },
  {
    "name": "Pune to Mumbai Airport Cab Service",
    "description": "Our Pune to Mumbai Airport Cab Service offers timely pickup, fixed fares, and comfortable chauffeur-driven travel."
  },
  {
    "name": "Pune to Mumbai Airport Taxi Service",
    "description": "Reserve Pune to Mumbai Airport Taxi Service with experienced drivers, AC vehicles, and dependable airport transfers."
  },
  {
    "name": "Pune to Mumbai Airport Cab Booking",
    "description": "Complete Pune to Mumbai Airport Cab Booking with instant confirmation and multiple vehicle choices."
  },
  {
    "name": "Online Pune to Mumbai Airport Taxi Booking",
    "description": "Use Online Pune to Mumbai Airport Taxi Booking for quick reservations with secure booking and transparent pricing."
  },
  {
    "name": "Book Taxi From Pune to Mumbai Airport",
    "description": "Book Taxi From Pune to Mumbai Airport anytime for comfortable airport travel with professional chauffeurs."
  },
  {
    "name": "Pune to Mumbai Airport One Way Taxi",
    "description": "Choose Pune to Mumbai Airport One Way Taxi and pay only for your single journey with fixed fares."
  },
  {
    "name": "Pune to Mumbai Airport Round Trip Taxi",
    "description": "Book Pune to Mumbai Airport Round Trip Taxi with flexible return timing and premium vehicles."
  },
  {
    "name": "Pune to Mumbai Airport Transfer",
    "description": "Reserve Pune to Mumbai Airport Transfer for smooth airport connectivity with reliable chauffeur service."
  },
  {
    "name": "Pune to Mumbai Airport Drop Taxi",
    "description": "Book Pune to Mumbai Airport Drop Taxi for direct airport drop with comfortable AC vehicles and affordable pricing."
  },
  {
    "name": "Pune to Mumbai Airport Pickup and Drop",
    "description": "Choose Pune to Mumbai Airport Pickup and Drop with timely pickup, professional drivers, and safe travel."
  },
  {
    "name": "Pune to Mumbai Airport Private Taxi",
    "description": "Hire Pune to Mumbai Airport Private Taxi for exclusive travel with premium vehicles and experienced chauffeurs."
  },
  {
    "name": "Pune to Mumbai Airport AC Taxi",
    "description": "Travel comfortably with Pune to Mumbai Airport AC Taxi featuring clean, air-conditioned vehicles."
  },
  {
    "name": "Pune to Mumbai Airport Intercity Taxi",
    "description": "Choose Pune to Mumbai Airport Intercity Taxi for reliable long-distance travel with fixed pricing."
  },
  {
    "name": "Pune to Mumbai Airport Car Rental",
    "description": "Book Pune to Mumbai Airport Car Rental with Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles."
  }
],

"tableData": [
  ["Taxi from Pune to Mumbai Airport", "Pune to Mumbai Airport Drop Charges"],
  ["Pune to Mumbai Airport Cab Services", "Pune to Mumbai Airport Car"],
  ["Pune to Mumbai Airport Car Hire", "Pune to Mumbai Airport Drop Taxi"],
  ["Pune to Mumbai Airport Drop Taxi Service", "Pune to Mumbai Taxi Hire"],
  ["Taxi Service from Pune to Mumbai Airport", "Taxi to Pune from Mumbai Airport"],
  ["Taxi From Pune to Mumbai Airport", "Pune to Mumbai Airport Taxi"],
  ["Pune to Mumbai Airport Cab", "Pune to Mumbai Airport Cab Service"],
  ["Pune to Mumbai Airport Taxi Service", "Pune to Mumbai Airport Cab Booking"],
  ["Online Pune to Mumbai Airport Taxi Booking", "Book Taxi From Pune to Mumbai Airport"],
  ["Pune to Mumbai Airport One Way Taxi", "Pune to Mumbai Airport Round Trip Taxi"],
  ["Pune to Mumbai Airport Transfer", "Pune to Mumbai Airport Drop Taxi"],
  ["Pune to Mumbai Airport Pickup and Drop", "Pune to Mumbai Airport Private Taxi"],
  ["Pune to Mumbai Airport AC Taxi", "Pune to Mumbai Airport Intercity Taxi"],
  ["Pune to Mumbai Airport Car Rental", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Taxi from Pune to Mumbai Airport",
    WhyChoosedescription: "Trustline Cab provides dependable taxi services from Pune to Mumbai Airport with timely pickups, comfortable vehicles, and professional chauffeurs."
  },
  {
    WhyChooseheading: "On-Time Airport Transfers",
    WhyChoosedescription: "Our drivers plan every journey carefully to help you reach Mumbai Airport well before your flight departure without unnecessary delays."
  },
  {
    WhyChooseheading: "Comfortable Fleet for Every Traveler",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers with spacious seating and ample luggage capacity."
  },
  {
    WhyChooseheading: "Professional Airport Chauffeurs",
    WhyChoosedescription: "Experienced drivers with excellent route knowledge ensure a safe, smooth, and hassle-free journey from Pune to Mumbai Airport."
  },
  {
    WhyChooseheading: "Transparent Airport Taxi Pricing",
    WhyChoosedescription: "Receive upfront fare quotations with competitive pricing and no hidden charges before confirming your airport taxi booking."
  },
  {
    WhyChooseheading: "Pickup from Any Location in Pune",
    WhyChoosedescription: "We provide doorstep pickup from homes, hotels, offices, Pune Airport, Pune Railway Station, and all major locations across Pune."
  },
  {
    WhyChooseheading: "Suitable for Domestic & International Flights",
    WhyChoosedescription: "Our Pune to Mumbai Airport taxi service is ideal for domestic passengers, international travelers, corporate executives, and families."
  },
  {
    WhyChooseheading: "Quick Booking with 24/7 Support",
    WhyChoosedescription: "Book your airport taxi anytime with instant confirmation and dedicated customer assistance available throughout the day."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide taxi service from Pune to Mumbai Airport?",
    answer: "Yes, Trustline Cab offers reliable taxi services from Pune to Mumbai Airport for domestic and international travelers."
  },
  {
    question: "Can I book a taxi to Mumbai Airport Terminal 1 and Terminal 2?",
    answer: "Yes, we provide direct airport transfers to both Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Which vehicles are available for Pune to Mumbai Airport travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable airport transfers."
  },
  {
    question: "Do you provide pickup from Pune Airport and Pune Railway Station?",
    answer: "Yes, we offer pickup from Pune Airport, Pune Railway Station, hotels, offices, and residential locations across Pune."
  },
  {
    question: "Can I book a one-way taxi to Mumbai Airport?",
    answer: "Yes, affordable one-way taxi services are available from Pune to Mumbai Airport with flexible pickup timings."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Toll charges, parking fees, airport parking, and applicable taxes are generally charged separately unless specifically mentioned in your booking quotation."
  },
  {
    question: "Is the airport taxi service available 24/7?",
    answer: "Yes, our Pune to Mumbai Airport taxi service operates 24 hours a day for early morning, daytime, and late-night flights."
  },
  {
    question: "Should I book my airport taxi in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and timely pickup according to your flight schedule."
  },
  {
    question: "Is this service suitable for business and family travelers?",
    answer: "Yes, our airport taxi service is ideal for business executives, tourists, families, students, and frequent flyers."
  },
  {
    question: "How can I book a Taxi from Pune to Mumbai Airport with Trustline Travels?",
    answer: "Simply share your pickup address, flight details, travel date, passenger count, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sanket Jadhav",
    feedback: "Excellent airport transfer service with perfect timing and professional coordination. The driver arrived before the scheduled pickup, and the journey to Mumbai Airport was smooth, comfortable, and completely hassle-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Poonam Agrawal",
    feedback: "Trustline Travels delivered a premium travel experience with a clean vehicle, courteous chauffeur, and seamless airport drop. The entire trip was well-organized, making the journey relaxing from start to finish.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi From Pune to Mumbai Airport Service",
  "image": "https://www.trustlinetravels.com/assets/images/taxi-from-pune-to-mumbai-airport.webp",
  "description": "Book taxi from Pune to Mumbai Airport with Trustline Travels for safe, comfortable, and affordable airport transfers. Get reliable airport drop cab services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium taxi options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6714"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/taxi-from-pune-to-mumbai-airport"
  }
};








  return (
    <div>
<Helmet>
  <title>Taxi From Pune to Mumbai Airport | Airport Cab Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book taxi from Pune to Mumbai Airport with Trustline Travels for reliable airport drop services. Get affordable Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs with professional drivers available 24x7."
  />

  <meta
    name="keywords"
    content="Taxi from pune to mumbai airport, Pune to mumbai airport drop charges, Pune to mumbai airport cab services, Pune to mumbai airport car, Pune to mumbai airport taxi, Pune Mumbai airport cab booking, Pune to Mumbai airport drop taxi, Pune airport to Mumbai airport cab, Pune Mumbai airport transfer service, Pune to Mumbai airport Innova cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/83.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Taxifrompunetomumbaiairport;